
export interface CustomerSession {
  id: number;
  sessionId: string;
  tableNumber: string;
  customerName?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  barId: string;
  status: 'ACTIVE' | 'EXPIRED' | 'CLOSED' | string;
  isActive: boolean;
  totalAmount: number;
  itemCount: number;
  lastActivity?: string | null;
  expiresAt?: string | null;
  notes?: string | null;
  orderId?: number | null;
  orderInvoice?: string | null;
  lastOrderTotal?: number | null;
  totalSpent?: number;
  expired?: boolean;
  createdAt?: string;
  updatedAt?: string;
}
